import { FilterDocument, FilterOptionKeys } from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const defaultFilterDocument: FilterDocument = {
  sortingMode: SortingMode.DeletedAt,
  groupByMode: GroupByMode.None,
  filters: {
    [FilterOptionKeys.Deleted]: true,
  },
  showCompleted: true,
};
